import { useState } from 'react';
import { Pagination, Navigation, Zoom } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
// Importing Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/zoom';

function Mobile_Slider({ imgArray }) {
  const [activeIndex, setActiveIndex] = useState(0); //Gives the value of active index
  return (
    <Swiper pagination={true} zoom={true} lazy={"true"} navigation={false} onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)} modules={[Pagination, Navigation, Zoom]} className="mySwiper z-20" >
      <div id="fraction" className="swiper-fraction transition-all ease-in-out delay-75">{activeIndex + 1}/{imgArray.length}</div>

      {imgArray.map((src, index) => (
        <SwiperSlide key={index}>
          <div className="swiper-zoom-container">

            <img src={src} className="object-contain aspect-[1/1] h-full w-full object-center mx-auto" alt="alternate" loading={"true"} />
            <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default Mobile_Slider;